import ReactDOM from "react-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Apollo from "./graphql";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { StateProvider } from "./contextAPI/StateProvider";
import reducer, { initialState } from "./contextAPI/reducer";

import global_es from "./translations/es/global.json";
import global_en from "./translations/en/global.json";
import global_fr from "./translations/fr/global.json";
import global_pt from "./translations/pt/global.json";
import ReactGA from "react-ga4";

const env = process.env.REACT_APP_ENV;

const options = {
  // order and from where user language should be detected
  order: ["navigator", "htmlTag", "path", "subdomain"],

  // keys or params to lookup language from
  lookupQuerystring: "lng",
  lookupCookie: "i18next",
  lookupLocalStorage: "i18nextLng",
  lookupSessionStorage: "i18nextLng",
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,

  // cache user language on
  caches: ["localStorage", "cookie"],
  excludeCacheFor: ["cimode"], // languages to not persist (cookie, localStorage)

  // optional expire and domain for set cookie
  cookieMinutes: 10,
  cookieDomain: "myDomain",

  // optional htmlTag with lang attribute, the default is:
  htmlTag: document.documentElement,

  // optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
  cookieOptions: { path: "/", sameSite: "strict" },
};

i18next.use(LanguageDetector).init({
  interpolation: { escapeValue: false },
  // lng: "en",
  detection: options,
  // supportedLngs: ['es', 'en', 'fr'],
  resources: {
    en: {
      global: global_en,
    },
    es: {
      global: global_es,
    },
    fr: {
      global: global_fr,
    },
    pt: {
      global: global_pt,
    }
  },
});

if (env === 'production') {
  ReactGA.initialize('UA-210316441-1');
}

console.log('env', env);


ReactDOM.render(
  <I18nextProvider i18n={ i18next }>
    <StateProvider reducer={reducer} initialState={initialState}>
      <Apollo /> 
    </StateProvider>
  </I18nextProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log outcomes (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
